/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingLinkRequestModel } from '../../models/onboarding-link-request-model';

export interface AdminGenerateBranchOnboardingLinkPost$Params {
      body?: OnboardingLinkRequestModel
}

export function adminGenerateBranchOnboardingLinkPost(http: HttpClient, rootUrl: string, params?: AdminGenerateBranchOnboardingLinkPost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, adminGenerateBranchOnboardingLinkPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<string>;
    })
  );
}

adminGenerateBranchOnboardingLinkPost.PATH = '/Admin/GenerateBranchOnboardingLink';
